import React, { useState } from "react";
import { Target, Eye, HeartHandshake, Users } from "lucide-react";
import CtaSection, { CtaButton } from "../components/common/CtaSection";
import LeadCaptureModal from "../components/common/LeadCaptureModal";
import { LEAD_CHANNELS } from "../constants/data";

const GOLD = "#50C878";
const NAVY = "#013220";

// ─── ABOUT US ─────────────────────────────────────────────────
// Placeholder copy throughout — the client edits text in place.
// CTAs appear in the hero, mid-page, and footer band so a visitor
// can always reach the team.
// ─────────────────────────────────────────────────────────────

const VALUES = [
  { icon: Target, title: "Our Mission", body: "To make premium home-buying affordable for every family by turning individual buyers into a collective with real negotiating power." },
  { icon: Eye, title: "Our Vision", body: "To become Hyderabad's most trusted real-estate platform, expanding group buying to every major city in India and across the world." },
  { icon: HeartHandshake, title: "Our Promise", body: "Transparency first. We never promise fixed discounts — we promise a better deal when we unite and go as group buyers, negotiated openly with the builder." },
  { icon: Users, title: "Our People", body: "A team of real estate experts who work for buyers, not builders." },
];

export default function AboutPage() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div style={{ background: "#F2F8F3", color: NAVY, minHeight: "100vh", paddingTop: "68px" }}>
      {/* Hero */}
      <div style={{ padding: "64px 24px 44px", textAlign: "center", background: "linear-gradient(135deg, rgba(80,200,120,0.10), rgba(127,217,160,0.04))", borderBottom: "1px solid rgba(80,200,120,0.2)" }}>
        <span style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.72rem", color: GOLD, letterSpacing: "0.18em", textTransform: "uppercase" }}>
          Who We Are
        </span>
        <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(2.2rem, 5vw, 3.4rem)", fontWeight: 600, margin: "12px 0 16px" }}>
          About GroupBuy Flats
        </h1>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "1.05rem", color: "rgba(1,50,32,0.7)", lineHeight: 1.7, maxWidth: "680px", margin: "0 auto 28px" }}>
         We're Hyderabad's first collective real-estate buying platform. By pooling demand from many buyers, we negotiate with top builders as one — so you get bulk pricing.
        </p>
        <CtaButton label="Register Your Interest" onClick={() => setShowModal(true)} />
      </div>

      {/* Story */}
      <section style={{ maxWidth: "820px", margin: "0 auto", padding: "60px 24px 20px" }}>
        <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "2rem", fontWeight: 600, marginBottom: "18px" }}>Our Story</h2>
        <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "1rem", color: "rgba(1,50,32,0.82)", lineHeight: 1.8, marginBottom: "16px" }}>
           GroupBuy Flats was founded on a simple belief: buying a home shouldn't mean walking into a builder's office alone, with no leverage. When buyers come together, the maths changes — and so does the price.
        </p>
        {/* <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "1rem", color: "rgba(1,50,32,0.82)", lineHeight: 1.8 }}>
          From a handful of families in Hyderabad to a growing community of buyers across Telangana, we've helped hundreds discover their homes on better terms. Every project we list is RERA-verified and legally checked before it reaches you.
        </p> */}
      </section>

      {/* Values grid */}
      <section style={{ maxWidth: "1100px", margin: "0 auto", padding: "30px 24px 60px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "22px" }}>
          {VALUES.map(({ icon: Icon, title, body }) => (
            <div key={title} style={{ background: "linear-gradient(135deg, #FFFFFF 0%, #F7FBF8 100%)", border: "1px solid rgba(80,200,120,0.18)", borderRadius: "14px", padding: "26px" }}>
              <div style={{ width: "44px", height: "44px", borderRadius: "10px", background: "rgba(80,200,120,0.12)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "16px" }}>
                <Icon size={22} color={GOLD} />
              </div>
              <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.4rem", fontWeight: 600, margin: "0 0 8px" }}>{title}</h3>
              <p style={{ fontFamily: "'Inter', sans-serif", fontSize: "0.92rem", color: "rgba(1,50,32,0.72)", lineHeight: 1.7, margin: 0 }}>{body}</p>
            </div>
          ))}
        </div>
      </section>

      <CtaSection
        eyebrow="Get to know us"
        title="Curious How GroupBuy Works?"
        subtitle="Our advisors are happy to walk you through the entire group-buying process — no obligation."
        primaryLabel="Register Your Interest"
        onPrimaryClick={() => setShowModal(true)}
      />

      <LeadCaptureModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        channel={LEAD_CHANNELS.WEB}
        prefillMessage="Enquiry from the About Us page"
      />
    </div>
  );
}
